import { useEffect } from 'react';
import { usePostEmergencySessionMutation } from '@rsos/reduxDataStore/src/features/emergencySession/emergencySessionApi';

/**
 * Custom hook to fetch ADR for a given telephone number
 * @param {String|Number} telNumber - telephone number
 */
const useFetchEmergencySessionForTel = telNumber => {
  const [trigger] = usePostEmergencySessionMutation();

  useEffect(() => {
    if (telNumber) {
      trigger({ query: `tel://${telNumber.toString()}` });
    }
  }, [telNumber, trigger]);

  return null;
};

export default useFetchEmergencySessionForTel;
